import React, { memo } from 'react'

import Sorting from 'Pods/SearchPage/Shared/Sorting/Sorting'
import { EVENT_SOURCE } from 'Pods/SearchPage/Shared/Tracking/constants'
import { FilterTrackingProvider } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'

import AssetTypeToggle from './Components/AssetTypeToggle/AssetTypeToggle'
import ClearFiltersButton from './Components/ClearFiltersButton/ClearFiltersButton'
import Designer from './Components/Designer/Designer'
import FileFormat from './Components/FileFormat/FileFormat'
import MoreFilters from './Components/MoreFilters/MoreFilters'
import Price from './Components/Price/Price'
import Quality from './Components/Quality/Quality'
import ResultsCount from './Components/ResultsCount/ResultsCount'

function MainFilters() {
  return (
    <FilterTrackingProvider eventSource={EVENT_SOURCE.FILTER_BAR}>
      <div className="search-page__main-filters">
        <div className="main-filters__primary">
          <AssetTypeToggle />
          {/* Price is the most used filter, so it leads the row wherever its slot is visible. */}
          <div className="main-filters__slot main-filters__slot--md">
            <Price />
          </div>
          <div className="main-filters__slot main-filters__slot--lg">
            <FileFormat />
          </div>
          <div className="main-filters__slot main-filters__slot--wide">
            <Quality />
          </div>
          {/* Server-rendered at every width; CSS shows it from xl, where More filters drops its
              Designer column (MoreFilters.jsx), so hydration never adds or removes it. */}
          <div className="main-filters__slot main-filters__slot--xl">
            <Designer />
          </div>
          <MoreFilters />
          <ClearFiltersButton />
        </div>
        {/* Figma 2989:109645: the count sits left of Sort. Below md Sort moves to row 2 (SearchPage). */}
        <div className="main-filters__secondary">
          <ResultsCount />
          <Sorting />
        </div>
      </div>
    </FilterTrackingProvider>
  )
}

export default memo(MainFilters)
